export function getTokenString(token: string): string {
  return `Bearer ${token}`;
}
